import buildFormReducer from 'reducers/builders/form';
import actionTypes, { actionTypeSections } from 'actiontypes/';
import { combineReducers } from 'redux';

const mainInitialState = {
  isRequesting: false,
};

const formInitialState = {
  email: {
    value: '',
    isValid: false,
    isValidating: false,
  },
};

function mainReducer(state = mainInitialState, action) {
  const actionType = action.type;

  switch (actionType) {
    case actionTypes.FORGOT_USERNAME_REQUEST.RESET_STATE:
      return { ...mainInitialState };
    case actionTypes.FORGOT_USERNAME_REQUEST.REQUEST_USERNAME_REQUEST:
      return {
        ...state,
        isRequesting: true,
      };
    case actionTypes.FORGOT_USERNAME_REQUEST.REQUEST_USERNAME_SUCCESS:
    case actionTypes.FORGOT_USERNAME_REQUEST.REQUEST_USERNAME_FAILURE:
      return {
        ...state,
        isRequesting: false,
      };
    default:
      return state;
  }
}

const requestReducer = combineReducers({
  main: mainReducer,
  form: buildFormReducer(formInitialState, actionTypeSections.FORGOT_USERNAME_REQUEST),
});

export { requestReducer as default };
